export const USER_OCPS_FEEDBACK_ENABLED: string = 'ocpsfeedbackenabled';
export const USER_OCPS_EMAIL_COLLECTION_ENABLED: string = 'ocpsemailcollectionenabled';
export const USER_OCPS_POLICIES_EXPIRATION: string = 'ocpspoliciesexpiration';

export const FEEDBACK_SETTING_ID = 'office16;L_SendFeedback';
export const EMAIL_COLLECTION_SETTING_ID = 'office16;L_EmailCollection';
export const CHECK_IN_INTERVAL_HEADER_KEY = 'CheckIn-Interval';

export const DEFAULT_CHECK_IN_INTERVAL = '90';
